<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0"></dialogos-app>
            </v-flex>
        </v-layout>
        <v-layout wrap row justify-center align-center text-xs-center class="cont_page">
          <v-flex class="cont-img animated fadeInUp dura-2" md7 sm7 xs11>
              <v-card color="transparent" flat tile>

                  <v-window v-model="onboarding">
                    <v-window-item  v-for="n in length" :key="`card-${n}`" >
                      <v-card class="cont_text-slider" color="transparent" flat >
                        <img :src="require('@/assets/unidad1/slide-14/slide-14-'+(onboarding+1)+'.jpg')" alt="" >
                        <h2>{{titulos[onboarding]}}</h2>
                        <p v-html="textos[onboarding]"></p>
                      </v-card>
                    </v-window-item>
                  </v-window>

                  <v-card-actions class="cont_buttons-slider">
                    <v-item-group light v-model="onboarding" class="text-center " mandatory>
                      <v-item v-for="n in length" :key="`btn-${n}`" v-slot:default="{ active, toggle }">
                        <v-btn :color="active ? '#3C9043' : '#D3D2D2'" small class="item-button" :input-value="active" icon @click="toggle">
                          <v-icon >mdi-record</v-icon>
                        </v-btn>
                      </v-item>
                    </v-item-group>
                  </v-card-actions>
              </v-card>
          </v-flex>
        </v-layout>
        <audio-player ref="audioPlayer" :autoplay="true" :audios="['slide14/Taxi','slide14/Doce','slide14/Tigre','slide14/Carate','slide14/Diamante','slide14/Cidade','slide14/Aceite']"></audio-player>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      currentText: 0,
      dialogos: [
        'Observe os diferentes casos em que aparece o som de [i].',
        'Depois de ler os casos, clique em “avançar” para fazer a atividade.'
      ],
      textos:[
      'Caso 1. A vogal I (ou IS) no final das palavras é pronunciada como em espanhol [i] (ou [is]).',
      'Caso 2. A vogal E (ou ES) no final das palavras é pronunciada como [i] (ou [is]). No entanto, se essa vogal for acentuada, a pronúncia será de [e].',
      'Caso 3. As letras T+ i serão pronunciadas como o som do [chi] em espanhol. As letras T + E ou ES nas sílabas finais também serão pronunciadas como o som do [chi] em espanhol.',
      'Caso 4. No entanto, se o "e" estiver acentuado, a pronúncia será [te], como em espanhol.', //pendiente imagen de carate
      'Caso 5. As letras D+ I ou IS serão pronunciadas como o som do [dyi] em espanhol.',
      'Caso 6. As letras D+ E ou ES também serão pronunciadas como [dyi] em espanhol no final das palavras.',
      'Caso 7. No entanto, se o "e" estiver acentuado, a pronúncia será [de], como em espanhol.' //pendiente imagen de aceite dende
      ],
      titulos:[
        'Táxi','Doce','Tigre', 'Caratê','Diamante','Cidade','Dendê',
      ],
      length: 7,
      onboarding: 0,
      valueLetra:0,
    }
  },
  watch: {
    onboarding(){
      if(this.onboarding == 0){
        this.$refs.audioPlayer.playAudio((0))
      }
      if(this.onboarding == 1){
        this.$refs.audioPlayer.playAudio((1))
      }
      if(this.onboarding == 2){
        this.$refs.audioPlayer.playAudio((2))
      }
      if(this.onboarding == 3){
        this.$refs.audioPlayer.playAudio((3))
      }
      if(this.onboarding == 4){
        this.$refs.audioPlayer.playAudio((4))
      }
      if(this.onboarding == 5){
        this.$refs.audioPlayer.playAudio((5))
      }
      if(this.onboarding == 6){
        this.$refs.audioPlayer.playAudio((6))
        this.$store.commit('nextShow', true);
        
      }
    }
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';
.cont_text-slider{
  height: auto;
  img{
    height: 150px;
  }
  p{
    font-family: Poppins-Regular;
    font-size: 12px;
  }
  h2{
    font-size: 17px;
    font-family: Poppins-Bold;
    margin: 0;
    padding: 0;
    
  }
}
.cont_buttons-slider{
  justify-content: center;
  .item-button{
    width: 20px;
    height: 20px;
  }
}
.cont-letras{
  .letra-button{
    border: solid $ibra-dark-blue;
    width: 53px;
    height: 53px;
    margin: 8px;
    border-radius: 10px;
    .t-blue{
      color: $ibra-dark-blue;
      font-family:Poppins-Regular;
      font-size: 35px;
      margin: 0;
      padding: 0;
      line-height: 0;
    }
  }
}
.active{
  background: $ibra-dark-blue;
  .t-blue{
    color: white!important;
  }
}

.t-first{
   font-family:Poppins-BoldItalic;
   font-size: 20px;
}

.img-letra{
  img{
    width: 200px;
    @media screen and (min-width: 900px) {
      width: 400px;
    }
  }
}
.cont-letras-textos{
    p{
      margin: 0;
      padding: 0;
      font-family:Poppins-Bold;
      font-size: 13px;
      padding: 5px;
    }
}

</style>
